import type React from "react";
import { useIntl } from "react-intl";

interface CartonCountSectionProps {
	count: number;
}

export const CartonCountSection: React.FC<CartonCountSectionProps> = ({ count }) => {
	const intl = useIntl();

	const suffix =
		count === 1
			? intl.formatMessage({ id: "carton", defaultMessage: "carton" })
			: intl.formatMessage({ id: "cartons", defaultMessage: "cartons" });

	return `${count} ${suffix}`;
};
